module.exports = __webpack_public_path__ + "img/bg-b@2x.26d367b9.png";